import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Notification as NotificationIcon } from "iconsax-react";
import { useLocation } from "react-router";
import { Button } from "@/shared/ui";
import { useGetUnreadCountQuery } from "../api";
import NotificationsPanel from "./NotificationsPanel";

export default function NotificationBell() {
  const { t } = useTranslation("Notifications");
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const { data: unreadData } = useGetUnreadCountQuery(undefined, {
    pollingInterval: 60_000,
    refetchOnFocus: true,
    skipPollingIfUnfocused: true,
  });

  const unreadCount = unreadData?.count ?? 0;

  useEffect(
    function closeOnNavigate() {
      setIsOpen(false);
    },
    [pathname],
  );

  function handleToggle() {
    setIsOpen((prev) => !prev);
  }

  function handleClose() {
    setIsOpen(false);
  }

  return (
    <div className="relative">
      <Button variant="secondary" isIconButton aria-label={t("bellLabel")} onClick={handleToggle} className="p-0!">
        <NotificationIcon size={20} color="currentColor" />
      </Button>

      {unreadCount > 0 && (
        <span className="pointer-events-none absolute -top-[3px] -right-[3px] z-101 w-2.5 h-2.5 radius-full surface-negative-fill" />
      )}

      {isOpen && (
        <>
          <div className="fixed inset-0 z-99" onClick={handleClose} />
          <div className="absolute right-0 top-full mt-2 z-100">
            <NotificationsPanel onClose={handleClose} />
          </div>
        </>
      )}
    </div>
  );
}
